import { Medscape } from 'www/medscape';

/* 
	This module assumes that the current video player isn't a playlist video player 
*/
class SponsoredVideo {
    constructor(config = null, SVP = null) {
    	let videoConfig = null;
        if (config != null) {
            videoConfig = Object.assign({}, config.video, { title: config.title });
        }
        this.videoConfig = videoConfig;
        this.SVP = SVP;
        this.subscriptions = [];
    }
    destroySubscriptions() {
        this.subscriptions.forEach(source => {
            source.unsubscribe();
        })
        this.subscriptions = [];
    }
    init() {
        const { videoConfig, SVP } = this;


        if (videoConfig != null && SVP != null) {
            const { AmpEventsSources } = SVP.amp;
            const ended$ = AmpEventsSources["ended"].subscribe(eventData => {
                if (eventData.videoId != videoConfig.videoId) {
                	this.loadVideo(videoConfig);
                }
            })
            const destroy$ = AmpEventsSources["destroy"].subscribe(eventData => {
                this.destroySubscriptions();
            })
            this.subscriptions.push(ended$)
            this.subscriptions.push(destroy$);
        }
    }
    loadVideo(video = null) {
        //const { StreamingVideoPlayer } = Medscape.modules;
        if (video != null) {
            const { SVP } = this;

            SVP.setMedia(video);
            // Chapters to show/hide while switch b/w videos
            let chaptersCon =  document.querySelector('.svp-module .chapters-plugin-container');
            if (chaptersCon) video.videoId !== "ifivideo" ? chaptersCon.classList.remove('hide') :chaptersCon.classList.add('hide');
        }
    }
}

export { SponsoredVideo }
/*


{
                video: {
                	"videoId": "ifiVideo",
                    "title": "Consider a Treatment for BRAF + MEK Inhibition",
                    "autoplay": true,
                    "source": "/delivery/31/53/31531921-2a4e-470d-a527-cb3f9b1b2b96/265123_MTV_Melanoma_S2_PROMO_VIDEO_Optimized_121818_1_,3000k,1000k,a96k,750k,400k,2500k,.mp4",
                    "poster": "",
                    "duration": 1103,
                    "ccFileRoot": "",
                    "ccInfo": []

                }
            }
*/